import { DefectsActions } from "../action-types/defectsActionTypes";

export const getDefectsList = (payload) => {
  return {
    type: DefectsActions.GET_DEFECTS_LIST,
    payload,
  };
};

export const setDefectsList = (payload) => {
  return {
    type: DefectsActions.SET_DEFECTS_LIST,
    payload,
  };
};
export const setDefectsPaginationList = (payload) => {
  return {
    type: DefectsActions.SET_DEFECTS_PAGINATION_LIST,
    payload,
  };
};

export const getDefectsDetailsList = (payload) => {
  return {
    type: DefectsActions.GET_DEFECTS_DETAILS_LIST,
    payload,
  };
};

export const setDefectsDetailsList = (payload) => {
  return {
    type: DefectsActions.SET_DEFECTS_DETAILS_LIST,
    payload,
  };
};

export const updateDefectsDetailsList = (payload) => {
  return {
    type: DefectsActions.UPDATE_DEFECTS_DETAILS_LIST,
    payload,
  };
};

export const isUpdateSuccessDefectsDetailsList = (payload) => {
  return {
    type: DefectsActions.IS_UPDATE_SUCCESS_DEFECTS_DETAILS,
    payload,
  };
};
